// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"edcf7960fa4a2569f6ab","339":"17caaa94cfcecd31d017"}[chunkId] + ".js";
};